import { render } from "./WilandBenchmark.vue?vue&type=template&id=103bbbd6"
import script from "./WilandBenchmark.vue?vue&type=script&setup=true&lang=js"
export * from "./WilandBenchmark.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Insights/WilandBenchmark.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "103bbbd6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('103bbbd6', __exports__)) {
    api.reload('103bbbd6', __exports__)
  }
  
  module.hot.accept("./WilandBenchmark.vue?vue&type=template&id=103bbbd6", () => {
    api.rerender('103bbbd6', render)
  })

}


export default __exports__